/**
 * Phone number helpers for Austrian (AT) login.
 */

/**
 * Normalize a user-entered phone number to the format the login backend expects:
 * the bare country code "43" followed by the national number without a leading zero.
 *
 * This matches what the checkout sends (intl-tel-input "standard" format) so that
 * both flows hit Logosoft with the same value.
 *
 * Examples:
 *   "0043664123456" / "00 43 664 123456" -> "43664123456"
 *   "+43 664 123456"                      -> "43664123456"
 *   "0664 123456"                         -> "43664123456"
 *   "664123456"                           -> "43664123456"
 *   "43664123456"                         -> "43664123456" (unchanged, idempotent)
 *
 * @param {string} phone Raw phone number as typed by the user.
 * @returns {string} Normalized number, or the original value when empty / has no digits.
 */
export default function normalizeAustrianPhone(phone) {
    if (!phone) {
        return phone;
    }

    // Keep digits only (drops "+", spaces, dashes, parentheses, etc.).
    let digits = String(phone).replace(/\D/g, '');

    if (!digits) {
        return phone;
    }

    if (digits.startsWith('00')) {
        // International "00" prefix -> bare country code (0043... -> 43...).
        digits = digits.slice(2);
    } else if (digits.startsWith('43')) {
        // Already in country-code form, leave as is.
    } else if (digits.startsWith('0')) {
        // National format with a leading zero (0664... -> 43664...).
        digits = `43${digits.slice(1)}`;
    } else {
        // National number without a leading zero (664... -> 43664...).
        digits = `43${digits}`;
    }

    return digits;
}
